import moment from 'moment';

import { buildCsv, CSV_MIME_TYPE } from './csv.helper';
import { buildListWorkbook, XLSX_MIME_TYPE } from './excel.helper';

import type { ExportFormat, ExportTable } from './export.types';

/** `map_<name>_<YYYYMMDD_HHmm>.(csv|xlsx)` */
export const getExportFileName = (name: string, format: ExportFormat, date: Date = new Date()): string =>
  `map_${name}_${moment(date).format('YYYYMMDD_HHmm')}.${format === 'csv' ? 'csv' : 'xlsx'}`;

const downloadBlob = (blob: Blob, fileName: string) => {
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  URL.revokeObjectURL(url);
};

export const buildBlob = async (table: ExportTable, format: ExportFormat, name: string): Promise<Blob> => {
  if (format === 'csv') {
    return new Blob([buildCsv(table)], { type: CSV_MIME_TYPE });
  }
  // exceljs is lazy loaded: it is only needed when the user picks Excel
  const { Workbook } = await import('exceljs');
  const buffer = await buildListWorkbook(new Workbook(), table, name).xlsx.writeBuffer();
  return new Blob([buffer], { type: XLSX_MIME_TYPE });
};

/** Generates the file in the browser and downloads it as `map_<name>_<date>.(csv|xlsx)`. */
export const downloadTable = async (table: ExportTable, format: ExportFormat, name: string): Promise<void> => {
  downloadBlob(await buildBlob(table, format, name), getExportFileName(name, format));
};
